// src/api/calendarApi.js
import api from "./api";

/**
 * Calendar API service
 * Provides methods for accessing calendar and task date endpoints
 */

// ==================== CALENDAR ENDPOINTS ====================

/**
 * Get tasks for a specific date
 * @param {string} date - Date in YYYY-MM-DD format (e.g., "2025-01-15")
 * @returns {Promise} Tasks for the specified date
 */
export const getTasksByDate = async (date) => {
  const response = await api.get(`/tasks/by-date/${date}`);
  return response.data.data;
};

/**
 * Get calendar data with task counts per date
 * @param {string} startDate - Start date in YYYY-MM-DD format (optional)
 * @param {string} endDate - End date in YYYY-MM-DD format (optional)
 * @returns {Promise} Calendar data with task counts grouped by date and status
 */
export const getCalendarData = async (startDate = null, endDate = null) => {
  const params = {};
  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;

  const response = await api.get("/tasks/calendar-data", { params });
  return response.data.data;
};

export default {
  getTasksByDate,
  getCalendarData,
};
